import React from 'react';
import { Field, reduxForm } from 'redux-form';
import PropTypes from 'prop-types';
import { Button, Spinner } from 'reactstrap';
import validateLogin from './validateLogin';
import t, { partial } from '../../../util/translation/translation';
import renderCountryPhone from './CountryPhone';

const p = partial('LogInForm');
const LogInForm = ({ handleSubmit, loading, goToEmail }) => {
  return (
    <form className="form account__form" onSubmit={handleSubmit}>
      <div className="form__form-group">
        <span className="form__form-group-label">{p('smsLogin')}</span>
        <div className="form__form-group-field">
          <Field
            name="username"
            component={renderCountryPhone}
            placeholder={t('shared.username')}
            autoComplete="username"
          />
        </div>
      </div>
      <Button color="primary" className="account__submit" disabled={loading}>
        {loading ? <Spinner size="sm" /> : p('logIn')}
      </Button>
      <div className="account__links">
        <button type="button" className="account__link" onClick={goToEmail}>
          {p('emailLogin')}
        </button>
      </div>
    </form>
  );
};

LogInForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
};

const reduxF = reduxForm({
  form: 'log_in_form',
  validateLogin,
});

export default reduxF(LogInForm);
